import Vue from "vue";
import App from "./App.vue";
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import store from "@/store";
import router from "@/router";
import "./plugins/element.js";
import api from '@/services/api'
import VueCookies from 'vue-cookies'


Vue.config.productionTip = false;

Vue.use(VueMaterial)
Vue.use(VueCookies)

const token = localStorage.getItem('token')

if (token) {
  api.defaults.headers.common['Authorization'] = `Token ${token}`
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
